module.exports = __webpack_public_path__ + "static/media/slider-2.a0e719b1.jpg";